import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../../helpers/api/apiCall";
import { Endpoints } from "../../../utils/Endpoints";

const initialState = {
  token: '',
  isLogged: false,
  loading: false,
  user: {}
};


export const sendOtpCode = createAsyncThunk("sendOtpCode", async (body) => {
  const response = await client.post(Endpoints.IDENTITY.SEND_OTP, body);
  return response.data;
});

export const validateSSOToken = createAsyncThunk("validateSSOToken", async (body) => {
  const response = await client.post(Endpoints.IDENTITY.VALIDATE_SSO_TOKEN, body);
  return response.data;
});

export const ssoLogin = createAsyncThunk("ssoLogin", async (body) => {
  const response = await client.post(Endpoints.IDENTITY.SSO_LOGIN, body);
  return response.data;
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken(state, action) {
      if (action.payload)
        state.isLogged = true;
      else
        state.isLogged = false

      state.token = action.payload
    },
    setUser(state, action) {
      state.user = action.payload
    }
  },
  extraReducers(builder) {
    builder.addCase(sendOtpCode.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(sendOtpCode.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(sendOtpCode.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(validateSSOToken.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(validateSSOToken.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(validateSSOToken.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(ssoLogin.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(ssoLogin.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(ssoLogin.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const { setToken, setUser } = authSlice.actions;
export default authSlice.reducer;
